import { useContext, useMemo } from "react";
import ArticleEventServices from "../services/articleEventServices";
import { AuthContext } from "../contexts/AuthContext";
import {
  getOrCreateSessionId,
  extractUtmParams,
  guessSource,
} from "../utils/trackingUtils";

const useArticleEvent = () => {
  const { api } = useContext(AuthContext);
  const service = useMemo(() => new ArticleEventServices(api), [api]);

  const getAllArticleEvent = () => {
    return service.getAll();
  };

  const getOneArticleEvent = (id) => {
    return service.getOne(id);
  };

  // type: 1 VUE, 2 CLIC, 3 CONTACT, 4 FAVORI, 5 APPEL, 6 PARTAGE_WHATSAPP, 7 PARTAGE_FACEBOOK, 8 MESSAGE
  const trackArticleEvent = (articleId, type, extra = {}) => {
    const referrer = document.referrer || null;
    return service.create({
      article: articleId,
      type,
      source: guessSource(referrer),
      referrer,
      utm: extractUtmParams(window.location.search),
      sessionId: getOrCreateSessionId(),
      ...extra, // permet de passer coupon: "..." si besoin
    });
  };

  const getGlobalStats = (params) => {
    return service.getGlobalStats(params);
  };

  const getArticleStatsTable = (params) => {
    return service.getArticleStatsTable(params);
  };
  const getArticleEventDetails = (articleId, params) => {
    return service.getArticleEventDetails(articleId, params);
  };

  return {
    getAllArticleEvent,
    getOneArticleEvent,
    trackArticleEvent,
    getGlobalStats,
    getArticleStatsTable,
    getArticleEventDetails,
  };
};

export default useArticleEvent;
